export const items = [
  {
    name: {
      first: 'Обзорная экскурсия по Санкт-Петербургу',
      second: ''
    },
    cost: 22500,
    dates: ['Вторник (19:00 - 22:00)', 'Четверг (19:00 - 22:00)'],
    period: 'Октябрь 2018 - Январь 2020',
    duration: '4 месяца'
  },
  {
    name: {
      first: 'Тематические экскурсии по Санкт-Петербургу',
      second: ''
    },
    cost: 22500,
    dates: ['Понедельник (19:00 - 22:00)', 'Среда (19:00 - 22:00)'],
    period: 'Февраль 2020 - Апрель 2020',
    duration: '3 месяца'
  },
  {
    name: {
      first: 'Пригороды Санкт-Петербурга',
      second: 'Петергоф, Царское Село и Павловск'
    },
    cost: 22500,
    dates: ['Вторник (19:00 - 22:00)', 'Четверг (19:00 - 22:00)'],
    period: 'Февраль 2020 - Апрель 2020',
    duration: '3 месяца'
  },
  {
    name: {
      first: 'Приморское кольцо',
      second: 'Ораниенбаум, Кронштадт, Выборг'
    },
    cost: 22500,
    dates: ['Понедельник (19:00 - 22:00)', 'Среда (19:00 - 22:00)'],
    period: 'Октябрь 2018 - Январь 2020',
    duration: '4 месяца'
  }
]

export const entryLvlCourseCost = [
  {
    paymentPeriod: '03 октября 2025 г.',
    month: 'Октябрь  2025',
    paymentMonth: '8 500 руб.'
  },
  {
    paymentPeriod: '05 ноября 2025 г.',
    month: 'Ноябрь 2025',
    paymentMonth: '8 500 руб.'
  },
  {
    paymentPeriod: '03 декабря 2025 г.',
    month: 'Декабрь 2025',
    paymentMonth: '8 500 руб.'
  },
  {
    paymentPeriod: '26 декабря 2025 г',
    month: 'Январь 2026',
    paymentMonth: '7 000 руб.'
  },
  {
    paymentPeriod: '4 февраля 2026 г. ',
    month: 'Февраль 2026',
    paymentMonth: '9 500 руб.'
  },
  {
    paymentPeriod: '4 марта 2026 г.',
    month: 'Март 2026',
    paymentMonth: '9 500 руб.'
  },
  {
    paymentPeriod: '3 апреля 2026 г.',
    month: 'Апрель 2026',
    paymentMonth: '9500 руб.'
  },
  {
    paymentPeriod: '6 мая 2026г.',
    month: 'Май 2026',
    paymentMonth: '8 000 руб.'
  }
]

export const advLvlCourseCost = [
  {
    paymentPeriod: '2 октября 2018 г.',
    month: 'Октябрь  2018',
    paymentMonth: '5 800  руб.'
  },
  {
    paymentPeriod: '6 ноября 2018 г.',
    month: 'Ноябрь 2018',
    paymentMonth: '6 700  руб.'
  },
  {
    paymentPeriod: '4 декабря 2018 г.',
    month: 'Декабрь 2018',
    paymentMonth: '6 500  руб.'
  },
  {
    paymentPeriod: '25 декабря 2018 г',
    month: 'Январь 2018 ',
    paymentMonth: '3 500  руб.'
  },
  {
    paymentPeriod: '5 февраля 2020 г. ',
    month: 'Февраль 2020',
    paymentMonth: '7 500  руб.'
  },
  {
    paymentPeriod: '5 марта 2020 г.',
    month: 'Март 2020',
    paymentMonth: '8 500  руб.'
  },
  {
    paymentPeriod: '2 апреля 2020 г.',
    month: 'Апрель 2020',
    paymentMonth: '6 500  руб.'
  }
]



// WEBPACK FOOTER //
// ./src/data/index.js